
// src/connects/division-export-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import config from '../config'
import map from 'lodash/map'
import moment from 'moment'

export const mapStateToProps = (state)=> {
  let fieldList = [];
  state.groups.items && state.groups.items.forEach(group => {
    state.templates.field_list && state.templates.field_list.forEach(item => {
        if (item.group_id === 0) {
          fieldList.push({
            group_id: group.group_id,
            fields: item.fields.map(i => ({group_id: group.group_id, name: i.name})),
          })
        }
        if (item.group_id === group.group_id) {
          fieldList.push(item)
        }
    })
  })
  return {
    access_token: state.sessions.access_token,
    field_list: fieldList,
    user: state.user.current,
    allGroups: state.groups.items,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      if(props.user && props.division && props.allGroups && props.division.groups[0]){
        const groups = props.allGroups.filter(group => props.division.groups.map(g => g.id).includes(group.group_id))
        dispatch(actions.fetchTemplateFields(groups.map(g => g.group_id).join(','), props.user.user_id, true))
      }
    },
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    groupExportUrl: (startDate, endDate, fields, group_ids)=> {
      const groups = stateProps.allGroups.filter(group => ownProps.division.groups.map(g => g.id).includes(group.group_id))
      var params = {
        group_ids: group_ids ? group_ids.join(',') : groups.map(g => g.group_id).join(','),
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
        selection_type: 'selection_group',
        access_token: stateProps.access_token,
      }
      if (fields) {
        let fieldNames = [];
        params.group_ids && params.group_ids.split(',').forEach(groupId => {
          fields.forEach(field => {
            if (field.group_id == groupId) {
              fieldNames.push(groupId + '_' + field.name)
            }
          })
        })
        params.group_field_names = fieldNames.join(',')
      }
      return `${config.baseUrl}v3/export/groups?${map(params, (value, key)=> `${key}=${encodeURI(value)}`).join('&')}`
    }
  })
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: { startDate: moment().startOf('month'), endDate: moment()}}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/division-export-panel.js